import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchModuleListData } from "./rolebaseAPI";
export interface ModuleListState {
  moduleListData: Array<any>;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: ModuleListState = {
  moduleListData: [],
  status: "idle",
};

export const GetModuleListData = createAsyncThunk("ModuleList/fetchModuleListData", async () => {
  const response = await fetchModuleListData();
  return response;
});

export const ModuleListSlice = createSlice({
  name: "ModuleList",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetModuleListData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetModuleListData.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetModuleListData.fulfilled, (state, action) => {
        state.status = "success";
        state.moduleListData = action.payload;
      });
  },
});

export const {} = ModuleListSlice.actions;

export const selectModuleListData = (state: RootState) => {
  return state.ModuleList.moduleListData;
};

export default ModuleListSlice.reducer;
